export default "__VITE_ASSET__B90ncAbP__"